export default {
  title: {
    id: 'bo_seller-options-batch_listing_creation-tips_title',
    defaultMessage: 'Tips to keep in mind',
  },
  content: {
    id: 'bo_seller-options-batch_listing_creation-tips_content',
    defaultMessage:
      'All empty cells are ignored by default. If you want to erase a listing field, type “#CLEAR#” into the cell in the CSV file. For item descriptions or comments, you can only use the following HTML tags: < a >, < abbr >, < acronym >, < b >, < blockquote >, < code >, < em >, < i >, < li >, < ol >, < strong >, < ul >, < div >, < br >, and < p >. Other tags will be removed.',
  },
}
